import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';

export interface AddInvestigationWatcherCommand {
  readonly investigationId: string;
  readonly userId: string;
}

@Injectable({ providedIn: 'root' })
export class AddInvestigationWatcherUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(command: AddInvestigationWatcherCommand): Observable<void> {
    return this._repository.addWatcher(command.investigationId, command.userId).pipe(
      catchError((error) => { throw error; }),
    );
  }
}
